export const PER_PAGE = 42; // "divisible by 3 and by 2"
export const MAX_RESULTS_COUNT = 1_000_000;
export const RANDOMIZATION_LIMIT = PER_PAGE * 50; // picked arbitrarily. first 50 pages = 2100 out of 2700+ highlight objects

export const searchFields = [
	{ value: '', name: 'All Fields' },
	// { value: 'ArtistCulture', name: 'Artist / Culture' }, converted into artist filter
	{ value: 'Title', name: 'Title' },
	{ value: 'Description', name: 'Description' },
	{ value: 'Gallery', name: 'Gallery' },
	{ value: 'AccessionNum', name: 'Object Number' },
	{ value: 'creditLine', name: 'Credit Line' },
	// { value: "provenance", name: "Provenance" }, // TODO: put this back in when provenance BE is ready
];

export const sortByFields = [
	{ value: '', name: 'Relevance' },
	{ value: 'Title', name: 'Title (a-z)' },
	{ value: 'TitleDesc', name: 'Title (z-a)' },
	{ value: 'DateDesc', name: 'Date (newest-oldest)' },
	{ value: 'Date', name: 'Date (oldest-newest)' },
	{ value: 'ArtistMaker', name: 'Artist/Maker (a-z)' },
	{ value: 'ArtistMakerDesc', name: 'Artist/Maker (z-a)' },
	{ value: 'AccessionNumber', name: 'Accession Number (0-9)' },
	{ value: 'AccessionNumberDesc', name: 'Accession Number (9-0)' },
];
